import { useState } from "react";
import "./login.css";
import { useAuth } from "../context/AuthContext";

export default function Login({ closePopup }) {

  const { login, signup } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSignup, setIsSignup] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (isSignup) {
        await signup(email, password);
      } else {
        await login(email, password);
      }

      closePopup();
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <div className="login-overlay">

      <div className="login-popup">

        <span className="close-btn" onClick={closePopup}>✖</span>

        <h2>{isSignup ? "Sign Up" : "Login"}</h2>

        <form onSubmit={handleSubmit}>

          <input
            type="email"
            placeholder="Enter Email"
            required
            onChange={(e) => setEmail(e.target.value)}
          />

          <input
            type="password"
            placeholder="Enter Password"
            required
            onChange={(e) => setPassword(e.target.value)}
          />

          <button type="submit">
            {isSignup ? "Sign Up" : "Login"}
          </button>

        </form>

        <p>
          {isSignup ? "Already have account?" : "Don't have account?"}

          <span
            className="switch-link"
            onClick={() => setIsSignup(!isSignup)}
          >
            {isSignup ? " Login" : " Sign Up"}
          </span>
        </p>

      </div>

    </div>
  );
}